import { CartAddEvent, CartErrorEvent, ThemeEvents } from '@theme/events';

class StickyBuyBar extends HTMLElement {
  #observer = null;
  #cta = null;
  #priceEl = null;
  #target = null;

  connectedCallback() {
    if (!window.matchMedia('(max-width: 749px)').matches) return;

    this.#cta = this.querySelector('[data-sticky-add]');
    this.#priceEl = this.querySelector('[data-sticky-price]');
    this.#target =
      document.querySelector('.product-form-buttons') ||
      document.querySelector('product-form-component');

    if (!this.#cta || !this.#target) return;

    this.#cta.addEventListener('click', this.#handleClick);
    document.addEventListener(ThemeEvents.variantUpdate, this.#handleVariantUpdate);

    this.#observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.classList.remove('is-visible');
          } else {
            this.classList.add('is-visible');
          }
        });
      },
      { rootMargin: '0px 0px 0px 0px', threshold: 0 }
    );
    this.#observer.observe(this.#target);
  }

  disconnectedCallback() {
    this.#observer?.disconnect();
    this.#cta?.removeEventListener('click', this.#handleClick);
    document.removeEventListener(ThemeEvents.variantUpdate, this.#handleVariantUpdate);
  }

  #handleVariantUpdate = (event) => {
    const variant = event.detail?.resource;
    if (!variant || !variant.id) return;

    this.dataset.variantId = String(variant.id);

    if (this.#cta) {
      if (variant.available === false) {
        this.#cta.setAttribute('disabled', 'true');
      } else {
        this.#cta.removeAttribute('disabled');
      }
    }
  };

  #handleClick = async (event) => {
    event.preventDefault();
    if (!this.#cta || this.#cta.hasAttribute('disabled')) return;

    const variantId = this.dataset.variantId;
    if (!variantId) return;

    this.#cta.setAttribute('disabled', 'true');

    try {
      const sectionIds = this.#getCartSectionIds();
      const body = {
        items: [{ id: parseInt(variantId, 10), quantity: 1 }],
      };
      if (sectionIds.length) body.sections = sectionIds.join(',');

      const response = await fetch(`${Theme.routes.root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body),
      });

      const data = await response.json();

      if (!response.ok || data.status) {
        const message = data.description || data.message || 'Errore. Riprova.';
        document.dispatchEvent(new CartErrorEvent('sticky-buy-bar', message));
        return;
      }

      document.dispatchEvent(
        new CartAddEvent({}, 'sticky-buy-bar', {
          source: 'sticky-buy-bar',
          itemCount: 1,
          sections: data.sections,
        })
      );

      const drawer = document.querySelector('cart-drawer-component');
      if (drawer && !drawer.hasAttribute('auto-open') && typeof drawer.open === 'function') {
        drawer.open();
      }
    } catch (e) {
      console.error(e);
    } finally {
      this.#cta?.removeAttribute('disabled');
    }
  };

  #getCartSectionIds() {
    const ids = new Set();
    document.querySelectorAll('cart-items-component').forEach((el) => {
      if (el instanceof HTMLElement && el.dataset.sectionId) {
        ids.add(el.dataset.sectionId);
      }
    });
    return Array.from(ids);
  }
}

if (!customElements.get('sticky-buy-bar')) {
  customElements.define('sticky-buy-bar', StickyBuyBar);
}
